import React from 'react';

const InputWithSave = ({
  onSave,
  onKeyDown,
  className = '',
  ...props
}) => {
  /**
   * Triggers onSave if CMD + S (Mac) or Ctrl + S (Win) is pressed
   * @param {event} event 
   */
  const handleKeyDown = (event) => {
    if (event.key.toLowerCase() === 's' && (event.metaKey || event.ctrlKey)) {
      event.preventDefault();
      onSave && onSave();
    }
    onKeyDown && onKeyDown(event);
  }
  return (
    <input
      {...props}
      className={`br-field__input ${className}`.trim()}
      onKeyDown={handleKeyDown}
    />
  )
}

export default InputWithSave;
